import React from 'react';
import { getWillShowNav3 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav3.tsx';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import ProjectKeyboardShortcuts from '@atlassian/jira-software-keyboard-shortcuts/src/ui/project-shortcuts/index.tsx';
import type { AppProps as Props } from './common/types';
import View from './ui';

export default function ReportPage({ baseUrl, boardId, children, reportType, projectKey }: Props) {
	const reportsUrl = `${baseUrl}/jira/software/projects/${projectKey}/boards/${boardId}/reports`;

	return (
		<ContextualAnalyticsData attributes={{ boardType: 'Agility' }}>
			{getWillShowNav3() && <ProjectKeyboardShortcuts boardId={boardId} projectKey={projectKey} />}
			{/* @ts-expect-error - TS2322 - Type '{ children: ReactNode; reportType: Report; reportsUrl: string; }' is not assignable to type 'IntrinsicAttributes & Partial<{ Header: AbstractComponent<Partial<{ BreadcrumbRenderer: AbstractComponent<Diff<any, { onMount: (analyticsEvent: UIAnalyticsEventInterface) => void; TenantContextSubscriber: SubscriberComponent<State, BoundActions<State, Actions>, unknown>; }>, any>; HowTo: ComponentType<...>; Chevron:...'. */}
			<View reportType={reportType} reportsUrl={reportsUrl} boardId={boardId}>
				{children}
			</View>
		</ContextualAnalyticsData>
	);
}
